module.exports = __webpack_public_path__ + "img/instruction_sheet_button.0592ac09.png";